// extracted by mini-css-extract-plugin
export default {"checkbox":"OptionGroup_checkbox__nhFrE","selected":"OptionGroup_selected__NlYZZ"};